"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
export const Heading = /*#__PURE__*/ React.forwardRef(function Heading(_param, ref) {
    var { tag = "h1" } = _param, props = _object_without_properties(_param, [
        "tag"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const Paragraph = /*#__PURE__*/ React.forwardRef(function Paragraph(props, ref) {
    return /*#__PURE__*/ React.createElement("p", _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const Emphasized = /*#__PURE__*/ React.forwardRef(function Emphasized(props, ref) {
    return /*#__PURE__*/ React.createElement("em", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
export const Strong = /*#__PURE__*/ React.forwardRef(function Strong(props, ref) {
    return /*#__PURE__*/ React.createElement("strong", _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const Figure = /*#__PURE__*/ React.forwardRef(function Figure(_param, ref) {
    var { className = "", figure } = _param, props = _object_without_properties(_param, [
        "className",
        "figure"
    ]);
    const { type, align } = figure;
    if (align) {
        className += `w-richtext-align-${align} `;
    }
    if (type) {
        className += `w-richtext-align-${type} `;
    }
    return /*#__PURE__*/ React.createElement("figure", _object_spread_props(_object_spread({
        className: className
    }, props), {
        ref: ref
    }));
});
export const Figcaption = /*#__PURE__*/ React.forwardRef(function Figcaption(props, ref) {
    return /*#__PURE__*/ React.createElement("figcaption", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
export const Subscript = /*#__PURE__*/ React.forwardRef(function Subscript(props, ref) {
    return /*#__PURE__*/ React.createElement("sub", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
export const Superscript = /*#__PURE__*/ React.forwardRef(function Superrscript(props, ref) {
    return /*#__PURE__*/ React.createElement("sup", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
export const RichText = /*#__PURE__*/ React.forwardRef(function RichText(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-richtext"
    }, props), {
        ref
    }));
});
